import styles from './index.module.scss'
import { Box } from '../Box'
import { Link } from '../Link'
import { Table } from '@tanstack/react-table'

interface SelectAllBarProps {
  getSelectAll: () => void
  getClearAll: () => void
  tableInstance: Table<any>
  getIsAllSelected: () => boolean
  selectAllHandler?: (isAllSelected: boolean) => void
  /**
   * We will not scan for more than select all threshold to determine if all rows are selected.
   * You might think we can just compare row count with selected rows and determine if all rows are selected
   * But we cannot take this approch since we have nested select, where our selected rows <= row count will always hold true
   * So we will scan for all nodes including leaf for upto `SELECTALL_THRESHOLD` value and bail out once the threshold is reached and will always return false
   * @default 3000
   */
  selectAllThreshold?: number
}

export const SelectAllBar = (props: SelectAllBarProps) => {
  const {
    getClearAll,
    getSelectAll,
    tableInstance,
    getIsAllSelected,
    selectAllThreshold = 3000,
    selectAllHandler,
  } = props

  const isSelectAll =
    tableInstance.getRowModel().flatRows.length <= selectAllThreshold
      ? getIsAllSelected()
      : false

  const selectAllFn = () => {
    getSelectAll()
    selectAllHandler?.(true)
  }

  return (
    <Box className={styles.selectNav}>
      <Link
        Component={'button'}
        color="primary"
        sx={{ textWeight: 'demi' }}
        onClick={selectAllFn}
        disabled={isSelectAll}
      >
        Select All
      </Link>
      <Link
        Component={'button'}
        color="primary"
        sx={{ textWeight: 'demi' }}
        onClick={getClearAll}
        disabled={
          Object.keys(tableInstance.getState().rowSelection).length <= 0
        }
      >
        Clear All
      </Link>
    </Box>
  )
}
